import { useState } from 'react';
import { MapPin, Route } from 'lucide-react';
import { PostcodeVisitSearch } from './PostcodeVisitSearch';
import { VehicleBreadcrumbViewer } from './VehicleBreadcrumbViewer';

/**
 * Settings > Vehicles > Historical Data Centre — standalone Samsara history
 * tools, independent of any Transport run/planned-stop data:
 *  1. Postcode Visit Search — did any of these vehicles visit this postcode,
 *     and when, across a date range.
 *  2. Vehicle Breadcrumb & Stops — full-day line map + auto-detected dwell
 *     dots for one vehicle, works for E70 even though its days aren't
 *     auto-populated with planned Transport stops.
 */
export const HistoricalDataCentre = () => {
  const [mode, setMode] = useState('postcode');

  return (
    <div className="space-y-4" data-testid="historical-data-centre">
      <div className="flex gap-2">
        <button
          onClick={() => setMode('postcode')}
          className={`flex items-center gap-1.5 text-sm font-semibold px-3 py-1.5 rounded-full border transition-colors ${mode === 'postcode' ? 'bg-slate-800 text-white border-slate-800' : 'bg-white text-slate-600 border-slate-300 hover:bg-slate-50'}`}
          data-testid="hdc-mode-postcode"
        >
          <MapPin className="w-3.5 h-3.5" /> Postcode Visit Search
        </button>
        <button
          onClick={() => setMode('breadcrumb')}
          className={`flex items-center gap-1.5 text-sm font-semibold px-3 py-1.5 rounded-full border transition-colors ${mode === 'breadcrumb' ? 'bg-slate-800 text-white border-slate-800' : 'bg-white text-slate-600 border-slate-300 hover:bg-slate-50'}`}
          data-testid="hdc-mode-breadcrumb"
        >
          <Route className="w-3.5 h-3.5" /> Vehicle Breadcrumb &amp; Stops
        </button>
      </div>
      {mode === 'postcode' ? <PostcodeVisitSearch /> : <VehicleBreadcrumbViewer />}
    </div>
  );
};

export default HistoricalDataCentre;
